export function changeStudentFilter(id, name) {
  return {
    type: 'CHANGE',
    id,
    name
  };
}

export function changeProductFilter(key) {
  return {
    type: 'CHANGE',
    key
  };
}

export function changeClassFilter(type, value) {
  return {
    type,
    value
  };
}

export function changeProjectFilter(type, value) {
  return {
    type,
    value
  };
}

export function addStudents(students) {
  return {
    type: 'ADD_STUDENTS',
    students
  };
}

export function addTeachers(teachers) {
  return {
    type: 'ADD_TEACHERS',
    teachers
  };
}

export function addClasses(classes) {
  return {
    type: 'ADD_CLASSES',
    classes
  };
}

export function changeClass(id, subject, name, grade, subjectId, students) {
  console.log('changeClass', id, subject, name, grade, subjectId, students);
  return {
    type: 'CHANGE_CLASS',
    id,
    subject,
    name,
    grade,
    subjectId,
    students
  };
}

export function addLogs(logs) {
  return {
    type: 'ADD_LOGS',
    logs
  };
}

export function yearChange(year, allYears) {
  return {
    type: 'CHANGE_YEAR',
    year,
    allYears
  };
}

export function logYears(years) {
  return {
    type: 'ADD_YEARS',
    years
  };
}



// WEBPACK FOOTER //
// ./src/actions/index.js